export default __webpack_public_path__ + "static/media/img-error.6ebfc38e.svg";